import { Button, Card, css, Heading, styled } from 'canoe';
import { connectWithHammock, ENDPOINTS } from 'hammock';
import React from 'react';

import { UpsertCollection } from '@candu-ai/collections/manage-collection';
import { hasPublisher, useHasPermission } from 'commons/auths';
import { useNavigation } from 'commons/hooks';
import { View } from 'dashboard/components/View';
import { CREATE_ROUTE } from 'dashboard/pages/Collection/pages/Create/constants';

import { CollectionList } from './components/CollectionList';

const StyledSection = styled.div`
  ${({ theme }) => css`
    display: block;
    padding: ${theme.spaces.normal};
    height: 100%;
  `}
`;

const FormWrapper = styled.div`
  margin: auto;
  max-width: 586px;

  button {
    margin: auto;
  }
`;

export interface CollectionsProps {
  resource: unknown[];
}

export const CollectionsImpl: React.FC<CollectionsProps> = ({
  resource: collectionList,
}: CollectionsProps) => {
  const navigate = useNavigation();
  const isPublisher = useHasPermission(hasPublisher);

  return (
    <View
      titleLvl1="Collections"
      subheader={
        Boolean(collectionList.length) &&
        isPublisher && (
          <Button
            appearance="outline"
            variant="orange"
            onClick={() => navigate(`./${CREATE_ROUTE.path}`)}
          >
            Create New Collection
          </Button>
        )
      }
    >
      {collectionList.length ? (
        <CollectionList canDelete={isPublisher} />
      ) : (
        <StyledSection id="empty-collections" data-cy="empty-placeholder">
          <Card>
            <FormWrapper>
              <Heading align="center" element="h3" size="XS">
                Create New Collection
              </Heading>
              <UpsertCollection context={{ canCreate: isPublisher }} />
            </FormWrapper>
          </Card>
        </StyledSection>
      )}
    </View>
  );
};

export const Collections = connectWithHammock({
  endpoint: ENDPOINTS.collections,
})(CollectionsImpl);
